import { LaunchDarklyFeatureFlags } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { LaunchDarklyGlobalFeatureFlags } from './LaunchDarklyGlobalFeatureFlags.types';
import { dashCaseToCamelCase } from '../impl/dashCaseToCamelCase';

const SESSION_FLAGS_KEYS = 'f:bGRDbGllbnRJZA==';

export function useDarklyMock() {
  const sessionFlags = window.sessionStorage.getItem(SESSION_FLAGS_KEYS);
  const flags = JSON.parse(sessionFlags ?? `{}`) as LaunchDarklyFeatureFlags;
  const camelCaseFlags = Object.entries(flags).reduce<Record<string, boolean>>((result, [key, value]) => {
    return {
      ...result,
      [dashCaseToCamelCase(key)]: value
    };
  }, {});
  return {
    enabled: !!sessionFlags,
    flags: {
      ...flags,
      ...camelCaseFlags
    }
  };
}

export function useGlobalDarklyMock() {
  const sessionFlags = window.sessionStorage.getItem(SESSION_FLAGS_KEYS);
  return {
    enabled: !!sessionFlags,
    flags: JSON.parse(sessionFlags ?? `{}`) as LaunchDarklyGlobalFeatureFlags
  };
}
